// src/components/SubmissionCards.jsx

const badge = (status) => {
  if (status === "Approved")
    return "bg-green-100 text-green-700 border border-green-300"

  if (status === "Rejected" || status === "Returned")
    return "bg-red-100 text-red-700 border border-red-300"

  if (status === "Pending" || status === "Submitted")
    return "bg-yellow-100 text-yellow-700 border border-yellow-300"

  return "bg-gray-100 text-gray-600 border border-gray-300"
}

export default function SubmissionCards({ data = [] }) {
  return (
    <section>
      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {data.length === 0 ? (
          <p className="text-gray-500 col-span-full text-center py-8">
            No recent submissions
          </p>
        ) : (
          data.map((esmp, i) => (
            <div
              key={esmp.id || i}
              className="border border-gray-200 bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition hover:-translate-y-1"
            >
              {/* District */}
              <p className="text-xs uppercase tracking-wide text-gray-400">
                District
              </p>

              <p className="text-sm text-gray-600 mb-1">
                {esmp.district}
              </p>

              {/* Project Name */}
              <h4 className="font-semibold text-lg mb-3 text-gray-800">
                {esmp.project_name || esmp.esmp_id || 'N/A'}
              </h4>

              {/* Status */}
              <span
                className={`
                  inline-block px-3 py-1 text-xs font-semibold rounded-full
                  ${badge(esmp.status)}
                `}
              >
                {esmp.status}
              </span>
            </div>
          ))
        )}
      </div>
    </section>
  )
}